
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/logistics-services",
      function () {
        return require("private-next-pages/web/logistics-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/logistics-services"])
      });
    }
  